export default "__VITE_ASSET__72a56034__"